export enum configTypes {
	Configruation = "Configurazione",
	Table = "Tabella",
	Group = "Gruppo"
}